/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the GenerateCrateRequestDto interface.
 */
export function instanceOfGenerateCrateRequestDto(value) {
    if (!('prompt' in value) || value['prompt'] === undefined)
        return false;
    return true;
}
export function GenerateCrateRequestDtoFromJSON(json) {
    return GenerateCrateRequestDtoFromJSONTyped(json, false);
}
export function GenerateCrateRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'prompt': json['prompt'],
        'additionalContext': json['additionalContext'] == null ? undefined : json['additionalContext'],
        'targetLength': json['targetLength'] == null ? undefined : json['targetLength'],
        'market': json['market'] == null ? undefined : json['market'],
        'mixableOrder': json['mixableOrder'] == null ? undefined : json['mixableOrder'],
        'bangersOnly': json['bangersOnly'] == null ? undefined : json['bangersOnly'],
        'maxPerArtist': json['maxPerArtist'] == null ? undefined : json['maxPerArtist'],
        'debug': json['debug'] == null ? undefined : json['debug'],
    };
}
export function GenerateCrateRequestDtoToJSON(json) {
    return GenerateCrateRequestDtoToJSONTyped(json, false);
}
export function GenerateCrateRequestDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'prompt': value['prompt'],
        'additionalContext': value['additionalContext'],
        'targetLength': value['targetLength'],
        'market': value['market'],
        'mixableOrder': value['mixableOrder'],
        'bangersOnly': value['bangersOnly'],
        'maxPerArtist': value['maxPerArtist'],
        'debug': value['debug'],
    };
}
